import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import documentTypeBasicInformationPropTypes from '../proptypes/DocumentTypePropTypes';

const DocumentTypeBasicInformationResource = ({
  name, description
}) => (
  <>
    <ResourceProperty label="Nombre:">{name}</ResourceProperty>
    <ResourceProperty label="Descripción:">
      {description || '-'}
    </ResourceProperty>
  </>
);

DocumentTypeBasicInformationResource.propTypes = documentTypeBasicInformationPropTypes;

export default DocumentTypeBasicInformationResource;
